import { abortIfNotPermitted, abortIfRequiresSubscription } from '../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "on-account" */ '@js/franchise_component/on-account/outlet-list.vue'),
        meta: {
            keepAlive: false, // does not need to be cached
        },
    },
    {
        path: '/local-account/:id',
        component: () =>
            import(/* webpackChunkName: "on-account" */ `@js/franchise_component/on-account/outlet-local-account-list.vue`),
        beforeEnter: (to, from, next) => {
            abortIfNotPermitted('franchise_view_local_account', next);
        },
        meta: {
            keepAlive: false, // does not need to be cached
        },
    },
    {
        path: '/local-account/:id/show/:account_id',
        component: () =>
            import(/* webpackChunkName: "on-account" */ `@js/franchise_component/on-account/outlet-local-account-show.vue`),
        beforeEnter: (to, from, next) => {
            abortIfNotPermitted('franchise_view_local_account', next);
        },
        meta: {
            keepAlive: false, // does not need to be cached
        },
    },
    {
        path: '/local-account/:id/topup/:account_id',
        component: () =>
            import(/* webpackChunkName: "on-account" */ `@js/franchise_component/on-account/topup-list.vue`),
        beforeEnter: (to, from, next) => {
            abortIfNotPermitted('franchise_view_local_account', next);
        },
        meta: {
            keepAlive: false, // does not need to be cached
        },
    },
    {
        path: '/local-account/:id/show/:account_id/vehicle/:vehicle_id',
        component: () =>
            import(/* webpackChunkName: "on-account" */ `@js/franchise_component/on-account/vehicle-on-account-show.vue`),
        beforeEnter: (to, from, next) => {
            abortIfNotPermitted('franchise_view_local_account', next);
        },
        meta: {
            keepAlive: false, // does not need to be cached
        },
    },
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/route-components/onaccount.js